

































































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Component } from "vue-property-decorator";

@Component
export default class CommunicationDashboardComponent extends Vue {    

    // redirect to the component
    redirect(name) {
        this.$router.push({
            name
        });
    }
  
}
